import { ReactElement } from 'react';
import { Box, Container, Typography } from '@mui/material';

import { BorderedPaper } from 'modules/common/components/BorderedPaper';
import { useTranslation } from 'modules/i18n';

import { DeFiTable } from '../../components/DeFiTable';
import { DEFIES_MOCK } from '../../const';
import { translation } from './translation';

export function DeFi(): ReactElement {
  const { t, keys } = useTranslation(translation);

  return (
    <Container>
      <BorderedPaper>
        <Box
          sx={theme => ({
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(5),
            position: 'relative',
          })}
        >
          <Typography textTransform="uppercase" variant="h5">
            {t(keys.title)}
          </Typography>

          <DeFiTable defies={DEFIES_MOCK} />
        </Box>
      </BorderedPaper>
    </Container>
  );
}
